import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/React.svg?component
var React_exports = /* @__PURE__ */ __exportAll({
	default: () => React_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("path", {
			fill: "#61DAFB",
			d: "M12.5 14.014a1.783 1.783 0 1 0 0-3.565 1.783 1.783 0 0 0 0 3.565"
		}, null, -1),
		createElementVNode("path", {
			stroke: "#61DAFB",
			"stroke-width": ".87",
			d: "M12.5 15.884c5.283 0 9.565-1.635 9.565-3.652S17.783 8.58 12.5 8.58s-9.565 1.635-9.565 3.652 4.282 3.652 9.565 3.652Z"
		}, null, -1),
		createElementVNode("path", {
			stroke: "#61DAFB",
			"stroke-width": ".87",
			d: "M9.337 14.058c2.642 4.575 6.199 7.466 7.946 6.457 1.746-1.008 1.021-5.534-1.62-10.11C13.02 5.832 9.464 2.94 7.717 3.949s-1.021 5.535 1.62 10.11Z"
		}, null, -1),
		createElementVNode("path", {
			stroke: "#61DAFB",
			"stroke-width": ".87",
			d: "M9.337 10.406c-2.641 4.575-3.366 9.1-1.62 10.11 1.747 1.008 5.304-1.883 7.946-6.458s3.366-9.101 1.62-10.11c-1.747-1.009-5.305 1.883-7.946 6.458Z"
		}, null, -1)
	])]);
}
var React_default = { render: render$1 };
//#endregion
export { React_exports, React_default as default, render$1 as render };

//# sourceMappingURL=React.svg_component.js.map